import { IItem } from "../types/common.interface";
import convertGregorianToJalali from "../utils/convertGregorianToJalali";

export const GENDER: IItem[] = [
  { name: "مرد", value: "MALE" },
  { name: "زن", value: "FEMALE" },
];
export const MARITAL: IItem[] = [
  { name: "متاهل", value: "SINGLE" },
  { name: "مجرد", value: "MARRIED" },
];
export const WEEK_DAY: IItem[] = [
  { _id: "1", name: "شنبه", value: "saturday" },
  { _id: "2", name: "یک شنبه", value: "sunday" },
  { _id: "3", name: "دو شنبه", value: "monday" },
  { _id: "4", name: "سه شنبه", value: "tuesday" },
  { _id: "5", name: "چهار شنبه", value: "wednesday" },
  { _id: "6", name: "پنج شنبه", value: "thursday" },
  { _id: "7", name: "جمعه", value: "friday" },
];

export const ORDER_STATUS = [
  { _id: "OPEN", name: "باز", value: "OPEN" },
  { _id: "DRIVER_ACC", name: "تایید راننده", value: "DRIVER_ACC" },
  { _id: "DONE", name: "تکمیل شده", value: "DONE" },
  { _id: "CANCELED", name: "لغو شده", value: "CANCELED" },
];
export const CATEGORY_BASE = [
  { _id: "home", name: "خانگی", value: "home" },
  {
    _id: "construction_waste",
    name: "نخاله ساختمانی",
    value: "construction_waste",
  },
  { _id: "well_emptying", name: "تخلیه چاه", value: "well_emptying" },
  { _id: "second_hand", name: "دست دوم", value: "second_hand" },
  { _id: "offices", name: "ادارات", value: "offices" },
  { _id: "hospital_waste", name: "بیمارستانی", value: "hospital_waste" },
  { _id: "industrial", name: "صنعتی", value: "industrial" },
];

export const TICKET_STATUS = [
  { _id: "PENDING", value: "PENDING", name: "درحال بررسی" },
  { _id: "CLOSED", value: "CLOSED", name: "بسته شده" },
  { _id: "ANSWERED", value: "ANSWERED", name: "پاسخ داده شده" },
];

export const ticketUserType = [
  {
    _id: "ADMIN",
    name: "پشتیبانی تفکیک",
  },
  {
    _id: "MUNICIPALITY",
    name: "شهرداری",
  },
  {
    _id: "COMPANY",
    name: "شرکت حمل و نقل",
  },
  {
    _id: "DRIVER",
    name: "راننده",
  },
  {
    _id: "CLIENT",
    name: "مشتری",
  },
];

export const CAR_MODAL = Array.from({ length: 43 }, (_, i) => {
  const this_year = Number(
    convertGregorianToJalali({
      date: new Date().toDateString(),
      format: "jYYYY",
    })
  );
  const value = this_year - i;
  return { _id: value, name: value.toString(), value };
});
